/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TableRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let group = this.modelFor('group');

    return hash({
      group,
      // Load all subjects, categories, subcategories, and goals into the model
      subjects: store.findAll('goals/subject'),
      categories: store.findAll('goals/category'),
      subcategories: store.findAll('goals/subcategory'),
      goals: store.findAll('goals/goal'),
      // Load the specific goal based on `goal_id`
      currentGoal: store
        .findRecord('goals/goal', params.goal_id)
        .then((goal) => {
          // Access the pre-combined goals list from the model
          const combinedGoalIds = goal.combinedGoals.map((g) => g.id);
          // Include the currentGoal's ID in the array of goal IDs
          const allGoalIds = [goal.id, ...combinedGoalIds];

          // Fetch states for each unique goal ID, including the current goal's ID
          return hash({
            goal,
            states: Promise.all(
              allGoalIds.map(
                (goalId) =>
                  store
                    .query('goals/state', {
                      goalId,
                      current: true,
                      groupId: group.id,
                    })
                    .catch(() => []), // Gracefully handle errors for each query
              ),
            ).then((statesArray) => statesArray.flat()), // Flatten the array of states
          });
        })
        .catch(() => null), // Fallback to null if `currentGoal` fetch fails
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    // Set the active tab.
    this.controllerFor('group.topics.topic').set(
      'topicTab',
      controller.topicTab,
    );
  }
}
